module.exports = __webpack_public_path__ + "img/phone-icon.0426810c.svg";